<template>
  <v-panel>
    <v-form ref="form" v-model="valid" >
      <div class="divider">
        <span>
          <b>Dados dos Recursos - Animais</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Reprodutores (Touros)</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm7 md7>
            <div class="divider2 text-xs-center">
              <span>
                <b>Touros existentes</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Residual</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="TourosValorResidual"
                  v-model="formulario.TourosValorResidual"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="TourosVidaUtil"
                  v-model="formulario.TourosVidaUtil"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Touros comprados no ano</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="TourosAno"
                  v-model="formulario.TourosAno"
                  type="number"
                  background-color="white"
                  label="cab"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <span>
            <b>Taxa de juros para calcular o custo do capital imobilizado em touros</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify row wrap>
          <v-flex xs6 sm5 md5>
            <v-text-field
              name="TaxaJurosTouros"
              v-model="formulario.TaxaJurosTouros"
              type="number"
              background-color="white"
              label="% anual"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Matrizes</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm7 md7>
            <div class="divider2 text-xs-center">
              <span>
                <b>Vacas existentes</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Residual</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VacasValorResidual"
                  v-model="formulario.VacasValorResidual"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VacasVidaUtil"
                  v-model="formulario.VacasVidaUtil"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Vacas compradas no ano</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="VacasAno"
                  v-model="formulario.VacasAno"
                  type="number"
                  background-color="white"
                  label="cab"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <span>
            <b>Taxa de juros para calcular o custo do capital imobilizado em matrizes</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify row wrap>
          <v-flex xs6 sm5 md5>
            <v-text-field
              name="TaxaJurosMatrizes"
              v-model="formulario.TaxaJurosMatrizes"
              type="number"
              background-color="white"
              label="% anual"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>

      <div class="divider2 text-xs-center">
        <span class="headline">
          <b>Animais de trabalho</b>
        </span>
      </div>
      <v-divider></v-divider>
      <v-layout align-center justify-center row wrap>
        <v-flex xs12 sm8 md8>
          <div class="divider2 text-xs-center">
            <span>
              <b>Equinos</b>
            </span>
          </div>
          <v-divider></v-divider>
          <v-layout align-center justify row wrap>
            <v-flex xs6 sm5 md5>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Cabeças</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-text-field
                name="EquinosCab"
                v-model="formulario.EquinosCab"
                type="number"
                background-color="white"
                label="cab"
                box
              ></v-text-field>
            </v-flex>

            <v-flex xs10 sm7 md7>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Valor</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-layout align-center justify-center row wrap>
                <v-flex xs6 sm5 md5>
                  <div class="divider2 text-xs-center">
                    <span>
                      <b>Inicial</b>
                    </span>
                  </div>
                  <v-divider></v-divider>
                  <v-text-field
                    name="EquinosValorInicial"
                    v-model="formulario.EquinosValorInicial"
                    type="number"
                    background-color="white"
                    label="R$/cab"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm5 md5>
                  <div class="divider2 text-xs-center">
                    <span>
                      <b>Residual</b>
                    </span>
                  </div>
                  <v-divider></v-divider>
                  <v-text-field
                    name="EquinosValorResidual"
                    v-model="formulario.EquinosValorResidual"
                    type="number"
                    background-color="white"
                    label="%"
                    box
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 sm5 md5>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Vida útil</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-text-field
                name="EquinosVidaUtil"
                v-model="formulario.EquinosVidaUtil"
                type="number"
                background-color="white"
                label="Anos"
                box
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm5 md5>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Utilização na bovinocultura de corte</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-text-field
                name="EquinosBovinoCultura"
                v-model="formulario.EquinosBovinoCultura"
                type="number"
                background-color="white"
                label="%"
                box
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-layout align-center justify-center row wrap>
        <v-flex xs12 sm8 md8>
          <div class="divider2 text-xs-center">
            <span>
              <b>Muares</b>
            </span>
          </div>
          <v-divider></v-divider>
          <v-layout align-center justify row wrap>
            <v-flex xs6 sm5 md5>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Cabeças</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-text-field
                name="MuaresCab"
                v-model="formulario.MuaresCab"
                type="number"
                background-color="white"
                label="cab"
                box
              ></v-text-field>
            </v-flex>

            <v-flex xs10 sm7 md7>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Valor</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-layout align-center justify-center row wrap>
                <v-flex xs6 sm5 md5>
                  <div class="divider2 text-xs-center">
                    <span>
                      <b>Inicial</b>
                    </span>
                  </div>
                  <v-divider></v-divider>
                  <v-text-field
                    name="MuaresValorInicial"
                    v-model="formulario.MuaresValorInicial"
                    type="number"
                    background-color="white"
                    label="R$/cab"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm5 md5>
                  <div class="divider2 text-xs-center">
                    <span>
                      <b>Residual</b>
                    </span>
                  </div>
                  <v-divider></v-divider>
                  <v-text-field
                    name="MuaresValorResidual"
                    v-model="formulario.MuaresValorResidual"
                    type="number"
                    background-color="white"
                    label="%"
                    box
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 sm5 md5>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Vida útil</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-text-field
                name="MuaresVidaUtil"
                v-model="formulario.MuaresVidaUtil"
                type="number"
                background-color="white"
                label="Anos"
                box
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm5 md5>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Utilização na bovinocultura de corte</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-text-field
                name="MuaresBovinoCultura"
                v-model="formulario.MuaresBovinoCultura"
                type="number"
                background-color="white"
                label="%"
                box
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="text-xs-center">
        <span>
          <b>Taxa de juros para calcular o custo do capital imobilizado em animais de trabalho</b>
        </span>
      </div>
      <v-divider></v-divider>
      <v-layout align-center justify row wrap>
        <v-flex xs6 sm5 md5>
          <v-text-field
            name="TaxaJuroAnimais"
            v-model="formulario.TaxaJuroAnimais"
            type="number"
            background-color="white"
            label="% anual"
            box            
          ></v-text-field>
          {{form}}
        </v-flex>
      </v-layout>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import DadosRecursosAnimais from "../../class/DadosRecursosAnimais.js";
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosRecursosAnimais(),
    panel: [],
    lazy: true,
    valid: false,
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosRecursosAnimais(dado.dadosRecursosAnimais);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>